import { Base } from "@tt-app/api/base";
import { API_ENDPOINTS } from "@tt-app/constants/api";
import { AxiosResponse } from "axios";
import { Achievements, ActivitySummary, ExerciseLog, PerformanceSummary } from "@tt-app/types";

const {
  LEARNING_HISTORY: {
    ACHIEVEMENT,
    ACTIVITY_SUMMARY,
    LEARNING_STATS,
    EXERCISE_LOGS,
    FEEDBACK,
    PERFORMANCE_SUMMARY,
    RECENT_EXERCISES
  }
} = API_ENDPOINTS;

class LearningHistory extends Base {
  async achievement(payload: any): Promise<AxiosResponse<Achievements>> {
    const headers = this.buildAuthHeaders(payload.authInfo);
    return this.httpClient.get(ACHIEVEMENT, { headers, params: payload.params });
  }

  async activitySummary(payload: any): Promise<AxiosResponse<ActivitySummary>> {
    const headers = this.buildAuthHeaders(payload.authInfo);
    return this.httpClient.get(ACTIVITY_SUMMARY, { headers, params: payload.params });
  }

  async exerciseLogs(payload: any): Promise<AxiosResponse<ExerciseLog[]>> {
    const headers = this.buildAuthHeaders(payload.authInfo);
    return this.httpClient.get(EXERCISE_LOGS, { headers, params: payload.params });
  }

  async learningStats(payload: any) {
    const headers = this.buildAuthHeaders(payload.authInfo);
    return this.httpClient.get(`${LEARNING_STATS}${payload.exerciseType}`, {
      headers,
      params: payload.params
    });
  }

  async performanceSummary(payload: any): Promise<AxiosResponse<PerformanceSummary>> {
    const headers = this.buildAuthHeaders(payload.authInfo);
    return this.httpClient.get(PERFORMANCE_SUMMARY, { headers, params: payload.params });
  }

  async userFeedback(payload: any): Promise<AxiosResponse<any>> {
    const headers = this.buildAuthHeaders(payload.authInfo);

    return this.httpClient.post(FEEDBACK, payload.params, { headers });
  }

  async recentExercises(payload: any): Promise<AxiosResponse<ExerciseLog[]>> {
    const headers = this.buildAuthHeaders(payload.authInfo);
    return this.httpClient.get(RECENT_EXERCISES, { headers, params: payload.params });
  }
}

export { LearningHistory };
